export default __webpack_public_path__ + "static/media/typegenerator.9a83e9d6.svg";